import React, { useCallback, useEffect, useState } from 'react'
import ReactTable from 'react-table'
import dayjs from 'dayjs'
import { InvoicePrint } from '../InvoicePrint'
import { LastUpdated } from '../LastUpdated'
import { useUpdateTab } from '../../hooks/useUpdateTab'
import { formatDifference } from 'src/utils/formatDifference'
import { getSuppliersReceivement } from 'src/services/suppliersQueue/suppliersQueueApi'
import * as S from './HistoryTab.styles'

const formatDate = (date) => {
  if (!date) {
    return ''
  }

  return dayjs(date).format('DD/MM/YYYY H:mm')
}

export const HistoryTab = ({ fulfillmentCenterId }) => {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [receivements, setReceivements] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const {
    loading, handleUpdate,
  } = useUpdateTab()

  const handlePageChange = (page) => {
    setPage(page + 1)
  }

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize)
  }

  const getReceivements = useCallback(() => getSuppliersReceivement({
    fulfillmentCenterId,
    page,
    pageSize,
  }), [fulfillmentCenterId, page, pageSize])

  const handleReceivementsResponse = useCallback((response) => {
    const {
      data: receivements,
      _meta: { total_pages: totalPages },
    } = response.data

    setTotalPages(totalPages)
    setReceivements(receivements)
  }, [])

  const updateReceivements = useCallback(() => handleUpdate(getReceivements, handleReceivementsResponse), [getReceivements, handleReceivementsResponse, handleUpdate])

  useEffect(() => {
    updateReceivements()
  }, [updateReceivements])

  useEffect(() => {
    const updateInterval = setInterval(updateReceivements, 60000)

    return () => {
      clearInterval(updateInterval)
    }
  }, [updateReceivements])

  return (
    <>
      <LastUpdated loading={loading} />

      <S.Wrapper>
        <ReactTable
          style={{ height: '100%' }}
          data={receivements.map((receivement) => ({
            supplier: receivement.fornecedor.nm_fornecedor,
            arrival: formatDate(receivement.data_inclusao),
            waitTime: formatDifference(
              receivement.data_inclusao,
              receivement.dt_inicio_recebimento,
            ),
            startReceivement: formatDate(receivement.dt_inicio_recebimento),
            endReceivement: formatDate(receivement.dt_fim_recebimento),
            receivementTime: formatDifference(
              receivement.dt_inicio_recebimento,
              receivement.dt_fim_recebimento,
            ),
            invoiceKeys: (
              <InvoicePrint invoiceKeys={receivement.chave_notas_fiscais} />
            ),
          }))}
          columns={[
            {
              Header: 'Fornecedor',
              id: 'supplier',
              accessor: 'supplier',
              minWidth: 360,
            },
            {
              Header: 'Chegada',
              id: 'arrival',
              accessor: 'arrival',
              width: 160,
            },
            {
              Header: 'Tempo Aguardando',
              id: 'waitTime',
              accessor: 'waitTime',
              width: 170,
            },
            {
              Header: 'Início Recebimento',
              id: 'startReceivement',
              accessor: 'startReceivement',
              width: 160,
            },
            {
              Header: 'Fim Recebimento',
              id: 'endReceivement',
              accessor: 'endReceivement',
              width: 150,
            },
            {
              Header: 'Tempo Recebimento',
              id: 'receivementTime',
              accessor: 'receivementTime',
              width: 170,
            },
            {
              Header: 'Notas Fiscais',
              id: 'invoiceKeys',
              accessor: 'invoiceKeys',
              width: 120,
            },
          ]}
          className='-striped -highlight'
          previousText='Anterior'
          nextText='Próxima'
          loadingText='Carregando...'
          noDataText='Sem registros'
          pageText='Página'
          ofText='de'
          rowsText='Registros'
          page={page - 1}
          pageSize={pageSize}
          pages={totalPages}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          manual
        />
      </S.Wrapper>
    </>
  )
}
